import styled from "styled-components";
import CheckCircleRoundedIcon from "@mui/icons-material/CheckCircleRounded";
//import InfoIcon from "@mui/icons-material/Info";
import CancelIcon from "@mui/icons-material/Cancel";
import PendingRoundedIcon from "@mui/icons-material/PendingRounded";
import MuiAccordionDetails from "@mui/material/AccordionDetails";
import MuiAccordion from "@mui/material/Accordion";
import MuiAccordionSummary from "@mui/material/AccordionSummary";

export const InfobarBlock = styled.section<{ heightBar?: number }>`
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow-y: auto;

  @media screen and (max-width: 1239px) {
    padding-bottom: 3px;
    height: ${(props) => (props.heightBar ? "calc( 100% - 70px)" : "100%")};
  }
`;

export const ButtonBlock = styled.div`
  margin-top: auto;
  position: sticky;
  bottom: 2px;
  background-color: var(--white);
  padding: 10px;
  display: flex;
  border-radius: 5px;
  justify-content: space-between;
  width: 100%;
  flex-direction: column;
  gap: 10px;
  box-shadow: rgba(0, 0, 0, 0.16) 0 1px 4px;

  @media (max-width: 1101px) {
    margin-top: 0;
    position: relative;
  }
`;

export const Accordion = styled(MuiAccordion)<{ $calculated?: number }>`
  &.MuiAccordion-root {
    &.MuiAccordion-gutters:not(:first-child) {
      margin-top: 12px;
    }
    & .Mui-expanded {
      min-height: max-content;

      padding: 0px;
    }
    border-radius: 10px !important;
    box-shadow: unset;
    border: 1px solid var(--background);
    &::before {
      display: none;
    }
  }
  & .MuiCollapse-root {
    max-height: ${(props) => `${props.$calculated}px` || "auto"};
  }
  box-sizing: border-box;
  @media (max-width: 1239px) {
    &.MuiAccordion-root {
      &.MuiAccordion-gutters:not(:first-child) {
        margin: 50px 10px 10px;
      }
      padding: 0 10px;

      & .MuiAccordionSummary-expandIconWrapper {
        display: none;
      }
    }
      @media (max-width: 768px) {
    &.MuiAccordion-root {
      &.MuiAccordion-gutters:not(:first-child) {
        margin: 20px 10px 10px;
      }
    }
  }
`;
export const AccordionDetails = styled(MuiAccordionDetails)`
  padding: 10px !important;
    @media (max-width: 768px) {
  padding-top: 0 !important;
  }

`;
export const AccordionStatusSign = styled(MuiAccordionDetails)`
  p {
    font-size: 10px;
    margin-bottom: 5px;
    font-weight: 700;
    color: var(--cadetGrey);
  }

  padding: 10px !important;
  height: min-content;
  overflow: auto;
`;

export const AccordionSummary = styled(MuiAccordionSummary)`
  &::before {
    display: none;
  }
  &.MuiAccordionSummary-root {
    padding: 0px;
  }
  &:last-child {
    margin-top: 40px;
  }
  flex-direction: row-reverse;
  align-items: center;
  gap: 10px;
  height: 60px;
  margin: 0;
  & .MuiAccordionSummary-contentGutters {
    flex-direction: column;
  }
  & .MuiAccordionSummary-expandIconWrapper.Mui-expanded {
    width: 40px;
    height: 40px;
    padding: 10px;
    transform: rotate(90deg);
  }
  & .MuiAccordionSummary-content {
    flex-grow: 1;
    margin: 0;
  }
  & .MuiAccordionSummary-expandIconWrapper {
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: transform 0.2s;
  }
  & .MuiAccordionSummary-expandIconWrapper.Mui-expanded {
    transform: rotate(90deg);
  }

  & .MuiAccordionSummary-contentGutters {
    flex-direction: column;
  }
  @media (max-width: 768px) {
  & .MuiAccordionSummary-content.Mui-expanded {
  margin: 6px 0;
  }
    }

`;

export const GeneralBlock = styled.div`
  h4 {
    color: var(--disabled-c);
    padding-bottom: 5px;
  }

  h5 {
    margin-left: 55px;
    word-wrap: break-word;
    overflow-wrap: break-word;
    font-size: 12px;
  }

  ul {
    margin-left: 55px;
    font-size: 12px;
  }
  li {
    padding-top: 10px;
  }
`;

export const StatusDoc = styled.div<{ $status?: string }>`
  font-size: 12px;
  padding-top: 3px;
  ${(props) =>
    props.$status === "failure" &&
    `
    color: var(--red);
  `};
  ${(props) =>
    props.$status === "successAll" &&
    `
    color: var(--signed-byAll-c);
  `};

  ${(props) =>
    props.$status === "success" &&
    `
    color: var(--signed-byYou-c);
  `};
  ${(props) =>
    props.$status === "loading" &&
    `
    color: var(--black);
  `};
  ${(props) =>
    props.$status === "wait" &&
    `
    color: var(--yellow);
  `};
  ${(props) =>
    props.$status === "readyToSign" &&
    `
    color: var(--blue);
  `};
  ${(props) =>
    props.$status === "cancelled" &&
    `
    color: var(--status-cancelled-color);
  `};
 
}
`;

export const Block = styled.div<{ $status?: string }>`
  div {
    font-size: 10px;
    margin-bottom: 5px;
    display: flex;
    align-items: center;
    font-weight: 700;
    gap: 5px;
    color: var(--cadetGrey);
  }
  margin-top: 10px;
  border-radius: 5px;
  padding: 0 11px;

  ${(props) =>
    props.$status === "failure" &&
    `
    // div {color: var(--red)};
    //background-color: var(--sign-failure);
  `};

  ${(props) =>
    props.$status === "cancelled" &&
    `
    div {color: var(--status-cancelled-color)};
    //background-color: var(--status-cancelled);
  `};

  ${(props) =>
    props.$status === "success" &&
    `
    // div {color: var(--signed)};
    // background-color: var(--signed-background);
  `};

  ${(props) =>
    props.$status === "loading" &&
    `
    // div {color: var(--black)};
    //background-color: var(--disabled-bg);
  `};
  ${(props) =>
    props.$status === "wait" &&
    `
    // div {color: var(--yellow)};
    // background-color: var(--sign-waiting);
    `}
`;

export const Person = styled.ul<{ $status?: string }>`
  font-size: 12px;
  border-radius: 10px;
  padding: 5px 11px;
  font-weight: 700;
  margin: 0 -11px;
  width: 100%;

  ${(props) =>
    props.$status === "failure" &&
    `
    background-color: var(--sign-failure);
  `};

  ${(props) =>
    props.$status === "cancelled" &&
    `
    background-color: var(--status-cancelled);
  `};

  ${(props) =>
    props.$status === "success" &&
    `
    div {color: var(--signed)};
     background-color: #F0FBEC;
  `};

  ${(props) =>
    props.$status === "loading" &&
    `
    div {color: var(--black)};
    background-color: var(--disabled-bg);
  `};
  ${(props) =>
    props.$status === "wait" &&
    `
    div {color: var(--yellow)};
    background-color: var(--sign-waiting);
    `}
`;

export const Details = styled.ul`
  // &:before {
  //   content: "";
  //   display: inline-block;
  //   height: 1px;
  //   width: 100%;
  //   background-color: var(--white);
  // }
  margin-top: 5px;
  font-size: 0.8rem;
  font-weight: 400;
`;

/---------icons------------/;
export const Divider = styled.div<{ $marginTop?: string; $marginBottom?: string }>`
  height: 1px;
  width: 100%;
  background-color: var(--background-gray);
  margin-top: ${(props) => (props.$marginTop ? props.$marginTop : "15px")};
  margin-bottom: ${(props) =>
    props.$marginBottom ? props.$marginBottom : "5px"};
`;

export const OkIcon = styled(CheckCircleRoundedIcon)`
  height: 0.8rem !important;
  width: 0.8rem !important;
  margin-right: 5px;
`;

export const ErrorIcon = styled(CancelIcon)`
  height: 0.8rem !important;
  width: 0.8rem !important;
  margin-right: 5px;
`;

export const ProcessIcon = styled(PendingRoundedIcon)`
  height: 0.8rem !important;
  width: 0.8rem !important;
  margin-right: 5px;
`;

export const PublicSign = styled.div`
  width: 100%;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--signed-background);
  padding: 10px;
  color: var(--signed);
  border-radius: 5px;
  font-size: 14px;
  @media (max-width: 991px) {
    width: calc(100% - 40px);
    position: absolute;
    bottom: 20px;
    left: 20px;
  }
`;
export const CrossBtn = styled.div`
  position: absolute;
  display: flex;
  z-index: 1;
  width: 30px;

  top: 10px;
  right: 10px;
  height: 30px;
  border: 1px solid black;
  border-radius: 10px;
  background-color: transparent;
  align-items: center;
  justify-content: center;

  &::before,
  &::after {
    content: "";
    position: absolute;
    width: 10px;
    height: 1px;
    background-color: #000;
  }

  &::before {
    transform: rotate(45deg);
  }

  &::after {
    transform: rotate(-45deg);
  }
  @media (max-width: 991px) {
    width: 18px;
    height: 18px;
    border-radius: 5px;
      top: 0px;
  right: 6px;

  }
`;

export const CrossBtnBurger = styled.div`
  display: flex;
  z-index: 1;
  width: 30px;

  height: 30px;
  border: 1px solid black;
  border-radius: 10px;
  background-color: transparent;
  align-items: center;
  justify-content: center;

  &::before,
  &::after {
    content: "";
    position: absolute;
    width: 10px;
    height: 1px;
    background-color: #000;
  }

  &::before {
    transform: rotate(45deg);
  }

  &::after {
    transform: rotate(-45deg);
  }
`;
